import React from "react";
import { ColumnProps } from "antd/es/table";
import Moment from "moment";
import {
  convertIosStringToDate,
  formatDateToString,
  formatToCurrencyType,
} from "helper/common";
import { FORMAT_TIME } from "types/enums";
import dayjs from "dayjs";
const columns: ColumnProps<any>[] = [
  {
    key: "1",
    title: "STT",
    dataIndex: "stt",
    align: "center",
    width: 120,
  },
  {
    key: "2",
    title: "Mã thuốc",
    dataIndex: "maThuoc",
    align: "left",
    width: 100,
  },
  {
    key: "4",
    title: "Hoạt chất",
    dataIndex: "hoatChat",
    align: "left",
    width: 100,
  },
  {
    key: "5",
    title: "Tên thuốc",
    dataIndex: "tenThuoc",
    align: "left",
    width: 100,
  },
  { key: "6", title: "Đơn vị tính", dataIndex: "donViTinh", align: "left", width: 100 },
  {
    dataIndex: "hamLuong",
    key: "7",
    title: "Hàm lượng",
    align: "right",
    width: 100,
  },
  {
    title: "Đường dùng",
    dataIndex: "duongDung",
    key: "9",
    align: "left",
    width: 100,
  },
  {
    title: "Mã đường dùng",
    dataIndex: "maDuongDung",
    key: "10",
    align: "left",
    width: 200,
  },
  {
    title: "Dạng bào chế",
    dataIndex: "dangBaoChe",
    key: "11",
    align: "left",
    width: 100,
  },
  {
    title: "Số Đăng kí",
    dataIndex: "soDangKi",
    key: "12",
    align: "left",
    width: 100,
  },
  {
    dataIndex: "soLuong",
    key: "13",
    title: "Số lượng thầu",
    align: "right",
    width: 100,
  },
  {
    dataIndex: "donGiaBv",
    key: "14",
    title: "Đơn giá BV",
    align: "right",
    width: 100,
  },
  {
    title: "Đơn giá BH",
    dataIndex: "donGiaBaoHiem",
    key: "15",
    align: "right",
    width: 100,
  },
  {
    title: "Quy cách",
    dataIndex: "quyCach",
    key: "16",
    align: "right",
    width: 100,
  },
  {
    dataIndex: "nhaSanXuat",
    key: "17",
    title: "Nhà sản xuất",
    align: "left",
    width: 150,
  },
  {
    dataIndex: "nuocSanXuat",
    key: "18",
    title: "Nước sản xuất",
    align: "right",
    width: 150,
  },
  {
    key: "19",
    title: "Nhà thầu",
    dataIndex: "nhaThau",
    align: "left",
    width: 100,
  },
  {
    key: "20",
    title: "Quyết Định Thầu",
    dataIndex: "quyetDinhThau",
    align: "left",
    width: 100,
  },
  {
    dataIndex: "tuNgay",
    key: "21",
    title: "Từ ngày",
    align: "center",
    width: 100,
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY");
      } else {
        return value; 
      }
    },
  },
  {
    dataIndex: "denNgay",
    key: "22",
    title: "Đến ngày",
    align: "center",
    width: 100,
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY");
      } else {
        return value; 
      }
    },
  },
  {
    dataIndex: "maCskcb",
    key: "23",
    title: "Mã CSKCB",
    align: "center",
    width: 100,
  },
  
  {
    title: "Loại thuốc",
    key: "24",
    dataIndex: "loaiThuoc",
    align: "left",
    width: 100,
  },
  
  {
    key: "25",
    title: "Loại thầu",
    dataIndex: "loaiThau",
    align: "left",
    width: 100,
  },

  {
    key: "26",
    title: "Thao tác",
    dataIndex: "action",
    width: 100,
    fixed: "right",
    align: "center",
  },
];
export { columns };
